/**
 * @generated SignedSource<<7c4afa3d5872913296ce4a6736f354f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type TaskRelayWrapperQuery_Query$variables = {
  pageSize?: number | null;
  searchQuery?: TaskSearchQueryType | null;
  convertToProjectCurrency?: boolean | null;
  financeServiceSearchQuery?: GlobalSearchFilterType | null;
};
export type TaskRelayWrapperQuery_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"TaskRelayWrapper_viewer">;
  } | null;
};
export type TaskRelayWrapperQuery_Query = {
  variables: TaskRelayWrapperQuery_Query$variables;
  response: TaskRelayWrapperQuery_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "convertToProjectCurrency"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "financeServiceSearchQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "task_relay_wrapper"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"task_relay_wrapper\")"
},
v6 = {
  "kind": "Variable",
  "name": "convertToProjectCurrency",
  "variableName": "convertToProjectCurrency"
},
v7 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v8 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = [
  (v9/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v19 = [
  (v9/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskRelayWrapperQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "financeServiceSearchQuery",
                "variableName": "financeServiceSearchQuery"
              },
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TaskRelayWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TaskRelayWrapperQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "allTasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomFieldValueV2TypeConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomFieldValueV2TypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "key",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v6/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "financeServiceSearchQuery"
                              }
                            ],
                            "concreteType": "FinancialNumbers",
                            "kind": "LinkedField",
                            "name": "financialNumbers",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actualRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "remainingRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "forecastRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionLockedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionOpenRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionForecastRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalActualRevenueRecognition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalForecastRevenueToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "surplus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "scopeApprovedMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalTimeAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "remainingMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billableActualMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nonBillableActualMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "registeredMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billablePlannedTimeAndExpenses",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 100000000
                              }
                            ],
                            "concreteType": "TimeRegTypeConnection",
                            "kind": "LinkedField",
                            "name": "timeRegistrations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeRegTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeRegType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minutesRegistered",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "billableMinutesRegistered",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "price",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": (v11/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "timeRegistrations(first:100000000)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullAccessToProject",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sortOrder",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "category",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyTaskId",
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestUiUpdateAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subTaskCount",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bug",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "blocked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highPriority",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "favoured",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasDependency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progress",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecast",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeLeft",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectedTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "companyProjectId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectEndDay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectEndMonth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectEndYear",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "estimationUnit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectColor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectGroupId",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Client",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RateCard",
                                "kind": "LinkedField",
                                "name": "rateCard",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskLabel",
                            "kind": "LinkedField",
                            "name": "taskLabels",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Label",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "color",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureDefaultId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v18/*: any*/),
                              (v17/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endDay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endMonth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endYear",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v17/*: any*/),
                              (v16/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isProjectGroupSprint",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectGroupSprintId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "followers",
                            "plural": true,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "searchQuery"
                ],
                "handle": "connection",
                "key": "Company_allTasks",
                "kind": "LinkedHandle",
                "name": "allTasks"
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8980d64579d16feed1db7ce9555bb713",
    "id": null,
    "metadata": {},
    "name": "TaskRelayWrapperQuery_Query",
    "operationKind": "query",
    "text": "query TaskRelayWrapperQuery_Query(\n  $pageSize: Int\n  $searchQuery: TaskSearchQueryType\n  $convertToProjectCurrency: Boolean\n  $financeServiceSearchQuery: GlobalSearchFilterType\n) {\n  viewer {\n    actualPersonId\n    component(name: \"task_relay_wrapper\")\n    ...TaskRelayWrapper_viewer_2oqclX\n    id\n  }\n}\n\nfragment TaskRelayWrapper_viewer_2oqclX on Viewer {\n  company {\n    currency\n    allTasks(first: $pageSize, searchQuery: $searchQuery) {\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n      edges {\n        node {\n          id\n          customFields {\n            edges {\n              node {\n                __typename\n                id\n                key\n                value\n                displayName\n              }\n            }\n          }\n          approved\n          financialNumbers(convertToProjectCurrency: $convertToProjectCurrency, searchQuery: $financeServiceSearchQuery) {\n            plannedRevenue\n            actualRevenue\n            remainingRevenue\n            forecastRevenue\n            recognitionLockedRevenue\n            recognitionOpenRevenue\n            recognitionForecastRevenue\n            totalActualRevenueRecognition\n            totalForecastRevenueToComplete\n            surplus\n            scopeApprovedMinutes\n            totalTimeAtCompletion\n            remainingMinutes\n            billableActualMinutes\n            nonBillableActualMinutes\n            registeredMinutes\n            billablePlannedTimeAndExpenses\n          }\n          timeRegistrations(first: 100000000) {\n            edges {\n              node {\n                id\n                minutesRegistered\n                billableMinutesRegistered\n                price\n                person {\n                  id\n                }\n              }\n            }\n          }\n          fullAccessToProject\n          sortOrder\n          statusColumnV2 {\n            id\n            name\n            category\n          }\n          companyTaskId\n          name\n          latestUiUpdateAt\n          subTaskCount\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          startYear\n          startMonth\n          startDay\n          bug\n          blocked\n          highPriority\n          billable\n          favoured\n          hasDependency\n          progress\n          currentPrice\n          estimateForecast\n          estimateForecastPrice\n          timeLeft\n          projectedTime\n          project {\n            id\n            status\n            companyProjectId\n            projectEndDay\n            projectEndMonth\n            projectEndYear\n            estimationUnit\n            projectColor\n            projectGroupId\n            name\n            client {\n              id\n              name\n            }\n            rateCard {\n              id\n              name\n            }\n          }\n          taskLabels {\n            label {\n              id\n              name\n              color\n            }\n            id\n          }\n          assignedPersons {\n            id\n            firstName\n            lastName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          role {\n            name\n            id\n          }\n          phase {\n            id\n            name\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            startDay\n            startMonth\n            startYear\n          }\n          sprint {\n            id\n            endDay\n            endMonth\n            endYear\n            startDay\n            startMonth\n            startYear\n            name\n            isProjectGroupSprint\n            projectGroupSprintId\n          }\n          owner {\n            id\n          }\n          followers {\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ea1b5c3c2a61086857c25c66398f672";

export default node;
